import type { Updaters } from '~/adapter/indexedDB/types'
import type { OfflineDownloadInfoSchemaV6 } from '../../6/downloadInfo/downloadInfo'
import type { EmployeeSchemaV6 } from '../../6/employee/employee'
import type { FeatureFlagSchemaV6 } from '../../6/featureFlag/featureFlag'
import type {
  MultipleChoiceSetSchemaV6,
  TemplateMultipleChoiceSetRelationSchemaV6,
} from '../../6/multipleChoiceSet/multipleChoiceSet'
import type {
  ReportManualSchemaV6,
  ReportNodeSchemaV6,
  ReportSchemaV6,
} from '../../6/report/report'
import type { ScheduleItemSchemaV6 } from '../../6/schedule/scheduleItem'
import type {
  TemplateNodeSchemaV6,
  TemplateSchemaV6,
} from '../../6/template/template'
import type { TemplateMediaSchemaV6 } from '../../6/template/templateMedia'
import type { VersionSchemaV6 } from '../../6/version/version'
import type { OfflineDownloadInfoSchemaV7 } from '../downloadInfo/downloadInfo'
import type { EmployeeSchemaV7 } from '../employee/employee'
import type { FeatureFlagSchemaV7 } from '../featureFlag/featureFlag'
import type {
  MultipleChoiceSetSchemaV7,
  TemplateMultipleChoiceSetRelationSchemaV7,
} from '../multipleChoiceSet/multipleChoiceSet'
import type {
  ReportManualSchemaV7,
  ReportNodeSchemaV7,
  ReportSchemaV7,
} from '../report/report'
import type { ScheduleItemSchemaV7 } from '../schedule/scheduleItem'
import type {
  TemplateNodeSchemaV7,
  TemplateSchemaV7,
} from '../template/template'
import type { TemplateMediaSchemaV7 } from '../template/templateMedia'
import type { VersionSchemaV7 } from '../version/version'

const version = 7
type versionType = typeof version

// V7: new-report 系の reportMode に optional な reportAssignee を復活させるだけの
// 型拡張であり、既存の永続データに変換は不要（未設定は undefined として通る）。
// version テーブルのみインクリメントする。
export const migration: Pick<
  Updaters[versionType],
  'upgradeBefore' | 'migrations'
> = {
  upgradeBefore: async () => {},
  migrations: {
    versions: (prev: VersionSchemaV6): VersionSchemaV7 => {
      return {
        ...prev,
        // NOTICE: version テーブルのインクリメントを忘れないこと
        version,
      }
    },
    featureFlags: (prev: FeatureFlagSchemaV6): FeatureFlagSchemaV7 => {
      return prev
    },
    reports: (prev: ReportSchemaV6): ReportSchemaV7 => {
      return prev
    },
    reportNodes: (prev: ReportNodeSchemaV6): ReportNodeSchemaV7 => {
      return prev
    },
    reportManuals: (prev: ReportManualSchemaV6): ReportManualSchemaV7 => {
      return prev
    },
    employees: (prev: EmployeeSchemaV6): EmployeeSchemaV7 => {
      return prev
    },
    offlineDownloadInfos: (
      prev: OfflineDownloadInfoSchemaV6,
    ): OfflineDownloadInfoSchemaV7 => {
      return prev
    },
    scheduleItems: (prev: ScheduleItemSchemaV6): ScheduleItemSchemaV7 => {
      return prev
    },
    templates: (prev: TemplateSchemaV6): TemplateSchemaV7 => {
      return prev
    },
    templateNodes: (prev: TemplateNodeSchemaV6): TemplateNodeSchemaV7 => {
      return prev
    },
    templateMedia: (prev: TemplateMediaSchemaV6): TemplateMediaSchemaV7 => {
      return prev
    },
    multipleChoiceSets: (
      prev: MultipleChoiceSetSchemaV6,
    ): MultipleChoiceSetSchemaV7 => {
      return prev
    },
    templateMultipleChoiceSetRelations: (
      prev: TemplateMultipleChoiceSetRelationSchemaV6,
    ): TemplateMultipleChoiceSetRelationSchemaV7 => {
      return prev
    },
  },
}
